import { NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { CommonModule } from '@angular/common'
import { TooltipModule } from 'ngx-bootstrap/tooltip'
import { ShowModalRoutingModule } from './show-modal-routing.module'
import { BookingModule } from '../../booking/booking.module'
import { ProductModule } from '../../product/product.module'
import { RaffleService } from '../raffle.service'
import { RaffleSerializer } from '../raffle.serializer'
import { RaffleEffects } from '../raffle.effects'
import * as fromRaffle from '../raffle.reducer'
import { RaffleLotModule } from '../raffle-lot/raffle-lot.module'
import { SubscriptionModule } from '../../subscription/subscription.module'

@NgModule({
  imports: [
    StoreModule.forFeature(fromRaffle.FEATURE_NAME, fromRaffle.raffleReducer),
    EffectsModule.forFeature([RaffleEffects]),
    TooltipModule.forRoot(),
    ShowModalRoutingModule,
    ProductModule,
    BookingModule,
    RaffleLotModule,
    SubscriptionModule,
    CommonModule
  ],
  providers: [
    RaffleService,
    {
      provide: RaffleSerializer,
      useClass: RaffleSerializer
    }
  ]
})
export class ShowModalModule {}
